import type { FaireProductEntity } from "../../entity_types/product";

export const p_7xc5ptag52: FaireProductEntity = {
  token: "p_7xc5ptag52",
  type: "product",
  name: "Birgitt Scarf#22",
  brandToken: "b_8r5hpus238",
  brandName: "GRIFFON 1924",
  imageUrl:
    "https://cdn.faire.com/fastly/4633694577ffcd06c626ab3d1a8ea128bc54357b5c3604b9e6a07082cc6336ae.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3a69c32ec8d350be8b7db396e52ead4d91225aea310773842601432e00cf9f2d.jpeg",
    "https://cdn.faire.com/fastly/240dffe7b6abae391c1a137751d5761766a3d96994794058795f115a6db64b23.jpeg",
    "https://cdn.faire.com/fastly/086f8ab7d9a804d8ac888c9a96f617f8dc14999c245fb0ddf824b3d5f163ebc9.jpeg",
    "https://cdn.faire.com/fastly/91a9276a35bce3eb53d89f38fb552648f04bf49e128a65a3d8108f5ec266e18c.jpeg",
    "https://cdn.faire.com/fastly/18ebb39b87d48a6af87adf5242062db3b8363ffd0cfdce536b86776bb257ba56.jpeg",
    "https://cdn.faire.com/fastly/ba649d07d74d749f10380602fc8f85bf1396feca88ebf7f38870893cb37b1b66.png",
    "https://cdn.faire.com/fastly/13bc622c773d6c3226f3b2e1f3ba1b5c7722fe20af5c0b96d6a28c19a32f6ee7.png",
  ],
  priceDollars: 18.39,
  description:
    "The BIRGITT scarf becomes an essential part of your wardrobe. For a more casual chic look, we like to wear it in the neckline of a coat, a puffer jacket, or a jacket, providing softness and warmth due to its material, made of wool and cashmere, and its flexibility, knitted in jersey. For a trendier look, we like to show it tied in the front, at the back, or like a bandana, over a sweater, a blouse, a t-shirt, and even worn covering the head, slightly at the back, tied at the bottom of the face, ensuring warmth and comfort. Knitted in jersey for more flexibility Wool and cashmere Length: +/- 105 cm Tip height: +/- 35 cm",
  tags: [],
  msrpDollars: 45.61,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:42.094Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
